import styled, { css, keyframes } from 'styled-components';
import { POPUP_ANIMATION_DURATION_SECOND } from '@/config/ui/time';
/* slide-in-out */
const slideIn = keyframes ` 
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`;
const slideOut = keyframes `
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
`;
const slideInOut = css `
  opacity: ${(props) => (props.isShow ? 1 : 0)};
  transition: opacity
    ${POPUP_ANIMATION_DURATION_SECOND.FADE - POPUP_ANIMATION_DURATION_SECOND.UNMOUNT}s ease-out;
  transition-delay: ${POPUP_ANIMATION_DURATION_SECOND.UNMOUNT}s;
  animation: ${(props) => (props.isShow ? slideIn : slideOut)}
    ${POPUP_ANIMATION_DURATION_SECOND.FADE}s;

  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
`;
/* fade-in-out */
const fadeIn = keyframes `
0% {
opacity: 0;
}
100%{
opacity: 1;
}
`;
const fadeOut = keyframes `
0% {
opacity: 1;
}
100%{
opacity: 0;
}
`;
const fadeInOut = css `
  animation: ${(props) => (props.isShow ? fadeIn : fadeOut)}
    ${POPUP_ANIMATION_DURATION_SECOND.FADE}s;

  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
`;
/* animation CSS map */
export const ANIMATION_MAP = {
    SLIDE_IN_OUT: slideInOut,
    FADE_IN_OUT: fadeInOut,
};
/* styled components */
export const S = {
    Animation: styled.div `
    ${(props) => props.animation};
    ${(props) => props.customStyle};
  `,
};
